/** 首页锚点与需预先挂载的区块序号对应关系 */
export const HOME_HASH_MIN_SECTION = {
  '#product': 1,
  '#journey': 1,
  '#flywheel': 2,
  '#calculator': 3,
  '#scenarios': 4,
  '#plans': 5,
  '#faq': 6,
  '#testimonials': 7,
};

export function normalizeHomeHash(hash) {
  if (!hash) return '';
  return hash.startsWith('#') ? hash : `#${hash}`;
}

export function getMinSectionForHash(hash) {
  return HOME_HASH_MIN_SECTION[normalizeHomeHash(hash)] ?? 0;
}

export function getHomeScrollOffset() {
  const padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop);
  return Number.isFinite(padding) ? padding : 80;
}

function getHashElement(hash) {
  const id = normalizeHomeHash(hash).slice(1);
  if (!id) return null;
  return document.getElementById(id);
}

/** 等待目标区块渲染后滚动定位 */
export function scrollToHomeHash(hash, behavior = 'smooth') {
  const target = normalizeHomeHash(hash);
  if (!target) return Promise.resolve();

  return new Promise((resolve) => {
    let attempts = 0;

    const tryScroll = () => {
      const el = getHashElement(target);
      if (!el) return false;
      const top = el.getBoundingClientRect().top + window.scrollY - getHomeScrollOffset();
      window.scrollTo({ top: Math.max(0, top), behavior });
      resolve();
      return true;
    };

    if (tryScroll()) return;

    const timer = window.setInterval(() => {
      attempts += 1;
      if (tryScroll() || attempts >= 100) {
        window.clearInterval(timer);
        resolve();
      }
    }, 50);
  });
}
